import { DataTable } from '@/common/ui/table/data-table'

import { columns } from './constants'

import type { CryptoInvoiceData } from '../../type'

interface CryptoInvoicesTableProps {
	data: CryptoInvoiceData[]
	isLoading?: boolean
}

export default function CryptoInvoicesTable({
	data,
	isLoading = false,
}: CryptoInvoicesTableProps) {
	return <DataTable columns={columns} data={data} isLoading={isLoading} />
}
